import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ManagerPortal } from './portal_bm/ManagerPortal';
import reportWebVitals from './reportWebVitals';

// The building manager portal is a separate tree, chosen here by path rather
// than by a role check inside App. That is deliberate: a manager must never
// see the staff navigation or any internal component, and the surest way to
// guarantee that is for the staff shell never to be constructed at all.
//
// react-router-dom is a dependency but has never been imported anywhere in
// this app — page switching is a string in App's state — so this stays with
// the grain rather than introducing a router for one branch.
//
// /bmportal rather than /portal, leaving the shorter path free for the other
// portals to come (building owners and so on), each its own tree.
const isManagerPortal = window.location.pathname.startsWith('/bmportal');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isManagerPortal ? <ManagerPortal /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
